"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OfferDetailsPage = void 0;
var OfferDetailsPage_1 = require("./OfferDetailsPage");
Object.defineProperty(exports, "OfferDetailsPage", { enumerable: true, get: function () { return OfferDetailsPage_1.OfferDetailsPage; } });
